import { Link, makeStyles, Theme } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { getI18n, useTranslation } from 'react-i18next';

type LinkI18NProps = {
    href: string;
    linkParam?: string;
    children: ReactNode;
};

const useStyles = makeStyles<Theme, LinkI18NProps>((theme) => ({
    root: {
        fontSize: 12,
        maxWidth: '100%',
        padding: '0px 8px',
        wordWrap: 'normal',
        [theme.breakpoints.down('xs')]: {
            flexGrow: 0,
            flexBasis: '100%',
        },
        [theme.breakpoints.up('sm')]: {
            flexGrow: 1,
            flexBasis: 'auto',
        },
    },
}));

const LinkI18N = (props: LinkI18NProps) => {
    const { href, linkParam, children } = props;
    const { t } = useTranslation();
    const classes = useStyles(props);

    let newHref = href;
    if (linkParam) {
        const currentLanguage = getI18n().language;
        const language = ['es', 'espanol'].includes(currentLanguage) ? 'es' : 'en';
        const url = new URL(href);
        url.searchParams.set(linkParam, language);
        newHref = url.toString();
    }

    return (
        <Link href={newHref} className={classes.root} color='inherit'>
            {t(children)}
        </Link>
    );
};

export default LinkI18N;
